class ApiClient {

    static parseDate(str) {
      return new Date(str);
    }
  
    static convertToType(data, type) {
        if (data === null || data === undefined)
            return data
  
        switch (type) {
            case 'Boolean':
                return Boolean(data);
            case 'Integer':
                return parseInt(data, 10);
            case 'Number':
                return parseFloat(data);
            case 'String':
                return String(data);
            case 'Date':
                return ApiClient.parseDate(String(data));
            case 'Blob':
                return data;
            default:
                if (type === Object) {
                    // generic object, return directly
                    return data;
                } else if (typeof type === 'function') {
                    // for model type like: User
                    return type.constructFromObject(data);
                } else if (Array.isArray(type)) {
                    // for array type like: ['String']
                    var itemType = type[0];
  
                    return data.map((item) => {
                        return ApiClient.convertToType(item, itemType);
                    });
                } else if (typeof type === 'object') {
                    // for plain object type like: {'String': 'Integer'}
                    var keyType, valueType;
                    for (var k in type) {
                        if (Object.prototype.hasOwnProperty.call(type, k)) {
                            keyType = k;
                            valueType = type[k];
                            break;
                        }
                    }
  
                    var result = {};
                    for (var k2 in data) {
                        if (Object.prototype.hasOwnProperty.call(data, k2)) {
                            var key = ApiClient.convertToType(k2, keyType);
                            var value = ApiClient.convertToType(data[k2], valueType);
                            result[key] = value;
                        }
                    }
  
                    return result;
                } else {
                    // for unknown type, return the data directly
                    return data;
                }
        }
    }
}
  
export default ApiClient;